import TextContent from '../../Molecules/TextContent';

function TermsAndConditions() {
  return (
    <div className="flex flex-col items-center justify-between py-20">
      <div className="mx-auto w-full max-w-7xl px-7 text-sl-blue">
        <TextContent>
          <h1 className="page-header__title">
            Algemene Voorwaarden
          </h1>
          <h2 className="subtitle align-left">
            Algemene voorwaarden Synsel Techniek BV
          </h2>
          <p>
            <strong>Artikel 1. DEFINITIES</strong>
          </p>
          <ul>
            <li>
              1.1. In deze algemene voorwaarden worden de
              volgende termen, al dan niet in meer- c.q.
              enkelvoud vervoegd, in de navolgende betekenis
              gebruikt, voor zover uit de aard of strekking
              van de bedingen in deze algemene voorwaarden
              niet anders voortvloeit:
            </li>
          </ul>
          <p>
            A. Synsel Techniek: de gebruiker van deze
            algemene voorwaarden: Synsel Techniek BV
            gevestigd aan de Laan van de Dierenriem 26 te
            Apeldoorn, ingeschreven in het Handelsregister
            onder KvK-nummer 71300163;
          </p>
          <p>
            B. opdrachtgever: de natuurlijke persoon die
            handelt in de uitoefening van zijn beroep of
            zijn bedrijf dan wel de rechtspersoon met wie
            Synsel Techniek een overeenkomst heeft gesloten
            of beoogt te sluiten;
          </p>
          <p>
            C. kandidaat: de natuurlijke persoon die bij
            Synsel Techniek wordt of is ingeschreven met het
            oog op het verrichten van werkzaamheden door
            tussenkomst van Synsel Techniek;
          </p>
          <p>
            D. gedetacheerde: de kandidaat die in het kader
            van een detacheringsovereenkomst aan de
            opdrachtgever ter beschikking wordt gesteld;
          </p>
          <p>
            E. overeenkomst: iedere overeenkomst tussen de
            opdrachtgever en Synsel Techniek;
          </p>
          <p className="nitro-offscreen">
            F. zoekopdracht: de overeenkomst waarbij de
            opdrachtgever aan Synsel Techniek de opdracht
            heeft verstrekt tot het zoeken, voordragen of
            voorstellen van kandidaten in het kader van
            detachering. Het doel van de zoekopdracht is de
            totstandkoming van een detacheringsovereenkomst;
          </p>
          <p className="nitro-offscreen">
            G. gelieerde onderneming: iedere natuurlijke
            persoon, rechtspersoon, maatschap, vennootschap
            onder firma, coöperatie, of commanditaire
            vennootschap die, direct dan wel indirect,
            verbonden is aan de opdrachtgever. Hieronder
            worden in ieder geval, doch niet uitsluitend,
            begrepen: vennootschappen behorende tot dezelfde
            groep of hetzelfde concern als de opdrachtgever,
            deelnemingen en joint ventures van de
            opdrachtgever, alsmede andere partijen met wie
            de opdrachtgever een samenwerkingsverband is
            aangegaan dan wel met wie de opdrachtgever
            gezamenlijk in een bouwcombinatie optreedt;
          </p>
          <p className="nitro-offscreen">
            H. detacheringsovereenkomst: de overeenkomst
            waarbij een gedetacheerde ter beschikking wordt
            gesteld aan de opdrachtgever om onder diens
            leiding en toezicht werkzaamheden te verrichten;
          </p>
          <p className="nitro-offscreen">
            I. schriftelijk: zowel traditionele
            schriftelijke communicatie als communicatie per
            e-mail.
          </p>
          <p className="nitro-offscreen">
            <strong>Artikel 2. ALGEMENE BEPALINGEN</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              2.1. Deze algemene voorwaarden zijn van
              toepassing op elk aanbod van Synsel Techniek,
              waaronder, het al dan niet op verzoek van de
              opdrachtgever, het informeren van de
              opdrachtgever over een kandidaat, de
              zoekopdrachten en overeenkomsten.
            </li>
            <li>
              2.2. Indien de opdrachtgever eenmaal een
              zoekopdracht aan Synsel Techniek heeft
              verstrekt dan wel een overeenkomst met Synsel
              Techniek is aangegaan, zijn deze algemene
              voorwaarden tevens van toepassing op latere
              zoekopdrachten en latere overeenkomsten zonder
              dat Synsel Techniek gehouden is deze algemene
              voorwaarden steeds opnieuw aan de
              opdrachtgever ter hand te stellen.
            </li>
            <li>
              2.3. De toepasselijkheid van de algemene of
              andersluidende (inkoop)voorwaarden van de
              opdrachtgever wordt uitdrukkelijk van de hand
              gewezen.
            </li>
            <li>
              2.4. Van het bepaalde in deze algemene
              voorwaarden kan uitsluitend schriftelijk
              worden afgeweken. Indien en voor zover hetgeen
              partijen uitdrukkelijk schriftelijk zijn
              overeengekomen, afwijkt van het bepaalde in
              deze algemene voorwaarden, geldt hetgeen
              partijen uitdrukkelijk schriftelijk zijn
              overeengekomen.
            </li>
            <li>
              2.5. Vernietiging of nietigheid van één of
              meer van de bepalingen uit deze algemene
              voorwaarden, laat de geldigheid van de overige
              bedingen onverlet. De nietige of vernietigde
              bepalingen zullen door Synsel Techniek
              vervangen worden, waarbij voor zoveel mogelijk
              het doel en de strekking van de
              oorspronkelijke bepalingen in acht wordt
              genomen.
            </li>
            <li>
              2.6. Indien Synsel Techniek niet steeds
              strikte naleving van deze algemene voorwaarden
              verlangt, betekent dit niet dat de bepalingen
              daarvan niet van toepassing zijn, of dat
              Synsel Techniek in enigerlei mate het recht
              zou verliezen om in andere gevallen de stipte
              naleving van de bepalingen van deze algemene
              voorwaarden te verlangen.
            </li>
            <li>
              2.7. Synsel Techniek heeft het recht deze
              algemene voorwaarden gedurende de overeenkomst
              te wijzigen en de nieuwe algemene voorwaarden
              op de bestaande overeenkomsten van toepassing
              te verklaren. De opdrachtgever wordt
              schriftelijk of via de e-mail van de nieuwe
              versie van de algemene voorwaarden op de
              hoogte gesteld en van de datum waarop de
              nieuwe algemene voorwaarden in werking treden.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>Artikel 3. AANBOD EN PRIJZEN</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              3.1. Elk aanbod van Synsel Techniek is
              vrijblijvend, tenzij uitdrukkelijk anders is
              vermeld.
            </li>
            <li>
              3.2. Indien de aanvaarding (op ondergeschikte
              punten) afwijkt van het in de offerte
              opgenomen aanbod, is Synsel Techniek daaraan
              niet gebonden. De overeenkomst komt dan niet
              overeenkomstig deze afwijkende aanvaarding tot
              stand.
            </li>
            <li>
              3.3. Kennelijke fouten of vergissingen in
              publicaties, e-mailberichten of overeenkomsten
              van Synsel Techniek binden Synsel Techniek
              niet.
            </li>
            <li>
              3.4. Alle vermelde prijzen en tarieven zijn
              excl. btw.
            </li>
            <li>
              3.5. Tariefwijzigingen ten gevolge van
              cao-verplichtingen, wijzigingen in of ten
              gevolge van wet- en regelgeving zoals fiscale
              en sociale wet- en regelgeving en
              jurisprudentie (bijvoorbeeld over structurele
              toeslaguren), zoals stijging van premies en
              van de inlenersbeloning, worden met ingang van
              het tijdstip van die wijzigingen aan de
              opdrachtgever doorberekend, ook als deze
              wijzigingen zich voordoen tijdens de duur van
              de overeenkomst. Synsel Techniek zal de
              opdrachtgever het voornemen tot verhoging van
              het uurtarief schriftelijk of via de e-mail
              kenbaar maken. Synsel Techniek zal daarbij de
              omvang van en de datum waarop de verhoging zal
              ingaan, vermelden.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>
              Artikel 4. UITVOERING VAN DE OVEREENKOMST
            </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              4.1. De dienstverlening van Synsel Techniek
              bestaat uit het zoeken, voordragen en
              voorstellen van kandidaten met als doel het
              tot stand komen van een
              detacheringsovereenkomst.
            </li>
            <li>
              4.2. Synsel Techniek verbindt zich om zich
              naar beste inzicht en conform de normen van
              goed vakmanschap de overeenkomst uit te
              voeren.
            </li>
            <li>
              4.3. Het is Synsel Techniek te allen tijde
              toegestaan om voor de uitvoering van een
              zoekopdracht derden in te schakelen.
            </li>
            <li>
              4.4. Synsel Techniek garandeert niet dat de
              gedetacheerde voldoet aan de verwachtingen van
              de opdrachtgever.
            </li>
            <li>
              4.5. De gedetacheerde voert de werkzaamheden
              uit die partijen zijn overeengekomen. Het is
              de opdrachtgever enkel toegestaan de
              gedetacheerde andere werkzaamheden te laten
              uitvoeren indien Synsel Techniek daarmee
              uitdrukkelijk vooraf akkoord is gegaan.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>Artikel 5. DETACHERING</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              5.1. Een detacheringsovereenkomst strekt tot
              de terbeschikkingstelling van de betreffende
              gedetacheerde aan de opdrachtgever om onder
              leiding, toezicht en verantwoordelijkheid van
              de opdrachtgever werkzaamheden te verrichten.
            </li>
            <li>
              5.2. Teneinde kandidaten op detacheringsbasis
              aan opdrachtgevers ter beschikking te kunnen
              stellen, is Synsel Techniek een
              samenwerkingsverband aangegaan met
              Backofficebureau, onderdeel van P-Services HR
              Group. Backofficebureau verzorgt als
              servicepartner van Synsel Techniek het
              salaris, contractbeheer en de
              verzuimbegeleiding van gedetacheerden. De
              opdrachtgever stemt er met het aangaan van de
              detacheringsovereenkomst mee in dat
              Backofficebureau als zodanig jegens de
              opdrachtgever optreedt. Middels het invullen
              en ondertekenen van het “Overeenkomst van
              opdracht” gaat de opdrachtgever tevens een
              overeenkomst aan met Backofficebureau.
            </li>
            <li>
              5.3. De tussen de opdrachtgever en Synsel
              Techniek overeengekomen beloningsafspraken en
              looptijd van de detacheringsovereenkomst
              worden door Synsel Techniek aan de
              opdrachtgever middels een schriftelijke
              inleenovereenkomst bevestigd. Hetgeen in die
              inleenovereenkomst is vermeld, is, behoudens
              tegenbewijs, conform de overeenkomst tussen de
              opdrachtgever en Backofficebureau, met dien
              verstande dat de opdrachtgever en
              Backofficebureau ter zake aanvullende
              afspraken overeenkomen. Van de overeenkomst
              tussen de opdrachtgever en Backofficebureau
              maken voorts onder meer deel uit de regels
              omtrent het indienen van de tijdverantwoording
              en de arbeidsomstandigheden van de
              gedetacheerde. De “Algemene voorwaarden
              Backofficebureau” zijn naast de onderhavige
              algemene voorwaarden op de
              detacheringsovereenkomst van toepassing. Mocht
              strijdigheid bestaan tussen een toepasselijk
              contractueel beding overeengekomen tussen
              Backofficebureau en de opdrachtgever
              enerzijds, en Synsel Techniek en de
              opdrachtgever anderzijds, dan prevaleren de
              tussen Synsel Techniek en de opdrachtgever
              overeengekomen bedingen. De opdrachtgever
              vrijwaart Synsel Techniek van aanspraken uit
              overeenkomsten tussen de opdrachtgever en
              Backofficebureau.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>
              Artikel 6. LOOPTIJD VAN DE
              DETACHERINGSOVEREENKOMST
            </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              6.1. De looptijd van de
              detacheringsovereenkomst komen partijen
              schriftelijk overeen.
            </li>
            <li>
              6.2. Het is de opdrachtgever toegestaan de
              detacheringsovereenkomst tussentijds op te
              zeggen. Bij tussentijdse opzegging na de
              proeftijd geldt een opzegtermijn van één
              kalendermaand.
            </li>
            <li>
              6.3. Indien de opdrachtgever de
              detacheringsovereenkomst na het einde van de
              looptijd dan wel nadat de gedetacheerde meer
              dan 1.700 uur op basis van de
              detacheringsovereenkomst voor de opdrachtgever
              heeft gewerkt niet opzegt, dan loopt de
              detacheringsovereenkomst voor onbepaalde tijd
              door. De voor onbepaalde tijd verlengde
              detacheringovereenkomst kan te allen tijde
              worden opgezegd met inachtneming van een
              opzegtermijn van één kalendermaand.
            </li>
            <li>
              6.4. De detacheringsovereenkomst eindigt in
              elk geval van rechtswege indien de
              overeenkomst tussen Backofficebureau en de
              opdrachtgever is geëindigd door volbrenging
              daarvan, dan wel door opzegging, ontbinding of
              op welke andere grond dan ook.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>Artikel 7. RELATIEBEDING</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              7.1. Het is de opdrachtgever en de gelieerde
              ondernemingen niet toegestaan om binnen 12
              maanden nadat een kandidaat door Synsel
              Techniek is voorgesteld aan, aangeboden bij of
              in contact is gebracht met de opdrachtgever,
              deze kandidaat in dienst te nemen, dan wel
              anderszins direct of indirect via een andere
              partij dan Synsel Techniek voor zich laten
              werken. Indien de opdrachtgever of een
              gelieerde onderneming binnen de termijn
              genoemd in dit artikel met een kandidaat een
              arbeidsovereenkomst wenst aan te gaan of de
              kandidaat op andere grond, bijvoorbeeld op
              basis van een opdrachtovereenkomst of via
              tussenkomst van een derde, voor zich wenst te
              laten werken, dan dient de opdrachtgever voor
              deze tewerkstelling toestemming te vragen aan
              Synsel Techniek en zullen partijen met elkaar
              in overleg treden om de vaste vergoeding, die
              de opdrachtgever daarvoor aan Synsel Techniek
              verschuldigd is, vast te stellen. Deze
              vergoeding bedraagt minimaal € 20.000,-.
              Worden partijen het niet eens over de hoogte
              van de vergoeding, dan blijft de eerste zin
              van dit artikel van kracht en mag de kandidaat
              geen werkzaamheden voor de opdrachtgever
              uitvoeren gedurende de hierboven genoemde
              periode.
            </li>
            <li>
              7.2. Het is de opdrachtgever niet toegestaan
              om gegevens van een door Synsel Techniek
              voorgestelde kandidaat zonder voorafgaande
              schriftelijke toestemming van Synsel Techniek
              aan een derde (waaronder mede begrepen aan de
              opdrachtgever gelieerde ondernemingen) bekend
              te maken.
            </li>
            <li>
              7.3. Het is de opdrachtgever en gelieerde
              ondernemingen niet toegestaan gedurende de
              detacheringsovereenkomst de gedetacheerde in
              dienst te nemen of op andere grond,
              bijvoorbeeld op basis van een
              opdrachtovereenkomst of via tussenkomst van
              een derde, voor zich te laten werken.
            </li>
            <li>
              7.4. Indien de opdrachtgever in strijd handelt
              met artikel 7.2 of met artikel 7.3, dan is de
              opdrachtgever een direct opeisbare boete aan
              Synsel Techniek verschuldigd van € 20.000,-
              per overtreding, onverminderd het recht van
              Synsel Techniek de werkelijk door de
              overtreding van de opdrachtgever geleden
              schade van de opdrachtgever te vorderen.
            </li>
            <li>
              7.5. Het is de opdrachtgever en gelieerde
              ondernemingen niet toegestaan de gedetacheerde
              in dienst te nemen of op andere grond,
              bijvoorbeeld op basis van een
              opdrachtovereenkomst of via tussenkomst van
              een derde, voor zich te laten werken indien de
              detacheringsovereenkomst is geëindigd en de
              gedetacheerde nog geen 1.700 uur op basis van
              de detacheringsovereenkomst werkzaamheden voor
              de opdrachtgever heeft uitgevoerd, zonder
              daarvoor een redelijke vergoeding aan Synsel
              Techniek te betalen. Deze redelijke vergoeding
              wordt vastgesteld op minimaal € 20.000,-.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong>
              Artikel 8. Afwijkende declarabele uren
            </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              8.1. Partijen kunnen schriftelijk afwijken van
              het minimaal aantal declarabele uren van 1.700
              zoals genoemd in artikel 6.2, 6.3 en 7.5 van
              deze algemene voorwaarden. Indien partijen
              hiervan afwijken, dan blijven de artikelen
              6.2, 6.3 en 7.5 van toepassing en dient in
              deze artikelen onder “1.700 uur” te worden
              verstaan het minimaal aantal declarabele uren
              dat partijen zijn overeengekomen (in de
              overeenkomst aangeduid als “de
              detacheringstermijn”).
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> </strong>
            <strong>
              Artikel 9. VERPLICHTINGEN VAN DE OPDRACHTGEVER
            </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              9.1. De opdrachtgever is verplicht al zijn
              wettelijke verplichtingen na te komen.
            </li>
            <li>
              9.2. Het is de opdrachtgever niet toegestaan
              referenties in te winnen zonder voorafgaande
              toestemming van de kandidaat.
            </li>
            <li>
              9.3. De opdrachtgever is verplicht Synsel
              Techniek te informeren over de werksituatie
              van de kandidaat en dient een VGM formulier in
              te vullen, zodat Synsel Techniek aan zijn
              doorgeleidingsplicht kan voldoen.
            </li>
            <li>
              9.4. De opdrachtgever vrijwaart Synsel
              Techniek voor eventuele aanspraken van derden
              en van de gedetacheerde, die in verband met de
              uitvoering van de overeenkomst schade lijden
              en welke aan de opdrachtgever toerekenbaar is.
            </li>
            <li>
              9.5. De opdrachtgever is gehouden Synsel
              Techniek onverwijld te informeren omtrent
              feiten en omstandigheden die in verband met de
              uitvoering van de overeenkomst van belang
              kunnen zijn.
            </li>
            <li>
              9.6. De opdrachtgever is verplicht Synsel
              Techniek te informeren over de van toepassing
              zijnde inlenersbeloning.
            </li>
            <li>
              9.7. De gedetacheerde werkt onder leiding en
              toezicht van de opdrachtgever. Derhalve ligt
              de verantwoordelijkheid voor de uitvoering van
              de werkzaamheden volledig bij de
              opdrachtgever.
            </li>
            <li>
              9.8. De opdrachtgever zal Synsel Techniek
              steeds zo spoedig mogelijk schriftelijk of via
              de e-mail op de hoogte stellen van wijzigingen
              in zijn gegevens, zoals een wijziging van
              (post)adres, e-mailadres of telefoonnummer.
            </li>
            <li>
              9.9. Indien de opdrachtgever zijn
              verplichtingen jegens Synsel Techniek die
              voortvloeien uit deze algemene voorwaarden, de
              overeenkomst of de wet niet, niet naar behoren
              of niet tijdig nakomt of onrechtmatig jegens
              Synsel Techniek handelt, dan is Synsel
              Techniek gerechtigd de overeenkomst met de
              opdrachtgever te ontbinden en dient de
              opdrachtgever alle schade aan Synsel Techniek
              te vergoeden die Synsel Techniek daardoor
              lijdt, waaronder omzetverlies.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 10. </strong>
            <strong>AANSPRAKELIJKHEID EN VERJARING</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              10.1. Synsel Techniek kan niet gehouden worden
              tot het vergoeden van enige schade, die een
              direct of indirect gevolg is van:
            </li>
          </ul>
          <p className="nitro-offscreen">
            A. een gebeurtenis, die in feite buiten zijn
            macht ligt en aldus niet aan zijn doen en/of
            laten kan worden toegeschreven, zoals o.a.
            omschreven in artikel 11 van deze algemene
            voorwaarden;
          </p>
          <p className="nitro-offscreen">
            B. enige daad of nalatigheid van de
            opdrachtgever, diens ondergeschikten, dan wel
            andere personen, die door of vanwege de
            opdrachtgever te werk zijn gesteld.
          </p>
          <ul className="nitro-offscreen">
            <li>
              10.2. Synsel Techniek is jegens de
              opdrachtgever nimmer aansprakelijk voor welke
              schade dan ook en uit welke hoofde dan ook
              ontstaan, waaronder, doch niet uitsluitend,
              schade die de gedetacheerde dan wel diens
              rechtsopvolgers, zoals nabestaanden en
              verzekeraars, lijden in verband met de
              uitoefening van de werkzaamheden van de
              gedetacheerde, waaronder tevens begrepen
              schade ontstaan tijdens werkverkeer en/of
              tijdens vervoer dat op één lijn is te stellen
              met vervoer krachtens de arbeidsovereenkomst,
              alsmede voor schade opgelopen in een situatie
              en/of gedurende een periode die zodanige
              samenhang heeft met de uitoefening van de
              werkzaamheden dat deze schade naar maatstaven
              van redelijkheid en billijkheid en/of goed
              werkgeverschap niet voor rekening van de
              gedetacheerde komt.
            </li>
            <li>
              10.3. Synsel Techniek is jegens de
              opdrachtgever niet aansprakelijk voor welke
              schade dan ook en uit welke hoofde dan ook
              ontstaan, die de gedetacheerde door diens
              handelen of nalaten berokkent aan de
              opdrachtgever of derden.
            </li>
            <li>
              10.4. Synsel Techniek draagt generlei
              aansprakelijkheid voor verbintenissen
              aangegaan door gedetacheerde die de
              opdrachtgever of derden binden.
            </li>
            <li>
              10.5. Synsel Techniek is nimmer aansprakelijk
              voor schade ontstaan doordat hij is uitgegaan
              van door de opdrachtgever verstrekte onjuiste
              of onvolledige gegevens.
            </li>
            <li>
              10.6. Synsel Techniek is niet aansprakelijk
              voor schade, waaronder opgelegde boetes, welke
              is veroorzaakt doordat de opdrachtgever zijn
              verplichtingen niet is nagekomen welke volgen
              uit de overeenkomst, deze algemene voorwaarden
              of de wet.
            </li>
            <li>
              10.7. Synsel Techniek staat niet in voor de
              juistheid van de door de gedetacheerde
              verstrekte gegevens. Synsel Techniek is dan
              ook niet aansprakelijk indien blijkt dat de
              gedetacheerde aan Synsel Techniek en/of aan de
              opdrachtgever onjuiste en/of onvolledige
              gegevens heeft verstrekt.
            </li>
            <li>
              10.8. De opdrachtgever is verantwoordelijk
              voor zijn keuze voor een bepaalde kandidaat.
              Synsel Techniek is nimmer aansprakelijk voor
              schade ontstaan in verband met de
              omstandigheid dat om welke reden en op welk
              moment dan ook, blijkt dat de opdrachtgever
              een onjuiste keuze voor een bepaalde kandidaat
              heeft gemaakt. Dit geldt tevens voor het geval
              een kandidaat zich op enig moment en om welke
              reden dan ook terugtrekt.
            </li>
            <li>
              10.9. Synsel Techniek is nimmer aansprakelijk
              voor indirecte schade, waaronder begrepen
              geleden verlies, gederfde winst, schade als
              gevolg van bedrijfsstagnatie, immateriële
              schade, arbeidskosten, reputatieschade,
              opgelegde boetes en overige gevolgschade.
            </li>
            <li>
              10.10. Indien Synsel Techniek aansprakelijk
              mocht zijn voor enigerlei schade, dan is de
              aansprakelijkheid van Synsel Techniek beperkt
              tot het bedrag van de door de verzekeraar van
              Synsel Techniek gedane uitkering. Indien de
              verzekeraar in enig geval niet tot uitkering
              overgaat of de schade niet door de verzekering
              wordt gedekt, dan is de aansprakelijkheid van
              Synsel Techniek beperkt tot het bedrag dat de
              opdrachtgever betaald heeft voor de
              werkzaamheden van Synsel Techniek waarop de
              aansprakelijkheid betrekking heeft, met een
              maximum tot de betaalde vergoeding voor 3
              maanden.
            </li>
            <li>
              10.11. Alle rechtsvorderingen dient de
              opdrachtgever binnen 1 jaar in te stellen als
              de opdrachtgever niet tevreden is over de
              werkzaamheden dan wel het handelen van Synsel
              Techniek. Handelt de opdrachtgever niet
              tijdig, dan verjaart de rechtsvordering.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 11. </strong>
            <strong>OVERMACHT</strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              11.1. Synsel Techniek is niet gehouden tot het
              nakomen van enige verplichting uit de
              overeenkomst indien en voor zover hij daartoe
              gehinderd wordt door een omstandigheid die hem
              krachtens de wet, een rechtshandeling of in
              het maatschappelijk verkeer geldende
              opvattingen niet kan worden toegerekend. Onder
              overmacht wordt o.a. verstaan: weersinvloeden;
              overstromingen; aardverschuivingen en andere
              natuurrampen; terrorisme; belemmeringen door
              derden, die van overheden inbegrepen; ziekte
              of familieomstandigheden van de gedetacheerde;
              belemmeringen in het vervoer; oproeren,
              oorlogen of oorlogsgevaren; branden; diefstal;
              internetstoring; energiestoring;
              computerinbraak; storing in het e-mailverkeer;
              overheidsmaatregelen; wijzigingen in wet- en
              regelgeving.
            </li>
            <li>
              11.2. Indien de overmachtssituatie de nakoming
              van de overeenkomst blijvend onmogelijk maakt,
              zijn partijen gerechtigd de overeenkomst met
              onmiddellijke ingang te ontbinden.
            </li>
            <li>
              11.3. Indien Synsel Techniek ten tijde van het
              intreden van de overmachtssituatie reeds
              gedeeltelijk aan zijn verplichtingen heeft
              voldaan of nog gedeeltelijk aan zijn
              verplichtingen kan voldoen, is Synsel Techniek
              gerechtigd het reeds uitgevoerde,
              respectievelijk uitvoerbare gedeelte van de
              zoekopdracht of overeenkomst afzonderlijk te
              factureren als ware er sprake van een
              zelfstandige overeenkomst.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 12. </strong>
            <strong>BETALING </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              12.1. Ter zake een detacheringsovereenkomst
              geschiedt facturering aan de opdrachtgever
              door Backofficebureau.
            </li>
            <li>
              12.2. Indien de opdrachtgever direct door
              Synsel Techniek wordt gefactureerd, dan dient
              betaling te geschieden binnen 14 dagen na de
              factuurdatum.
            </li>
            <li>
              12.3. Indien een factuur van Synsel Techniek
              niet binnen de toepasselijke betalingstermijn
              is voldaan, treedt het verzuim van de
              opdrachtgever van rechtswege in. Vanaf de dag
              dat het verzuim van de opdrachtgever intreedt,
              is hij over het openstaande bedrag een rente
              van 1% per kalendermaand verschuldigd, waarbij
              een gedeelte van een kalendermaand als een
              volledige maand wordt aangemerkt.
            </li>
            <li>
              12.4. Reclames omtrent enige factuur van
              Synsel Techniek dienen binnen zeven dagen na
              factuurdatum schriftelijk bij Synsel Techniek
              te zijn ingediend, bij gebreke waarvan het
              recht van de opdrachtgever om ter zake nog te
              reclameren is komen te vervallen. Reclames
              schorten de betalingsverplichtingen van de
              opdrachtgever nimmer op.
            </li>
            <li>
              12.5. Alle buitengerechtelijke en
              gerechtelijke kosten, alsmede executiekosten,
              gemaakt ter verkrijging van de door de
              opdrachtgever aan Synsel Techniek
              verschuldigde bedragen, komen geheel voor
              rekening van de opdrachtgever.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 13. </strong>
            <strong>OPSCHORTING EN ONTBINDING </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              13.1. Alle vorderingen van Synsel Techniek op
              de opdrachtgever zijn onmiddellijk opeisbaar
              indien:
            </li>
          </ul>
          <p className="nitro-offscreen">
            A. de opdrachtgever in staat van faillissement
            verkeert, (voorlopige) surseance van betaling
            heeft aangevraagd dan wel de Wet Schuldsanering
            Natuurlijke Personen op hem van toepassing is
            verklaard;
          </p>
          <p className="nitro-offscreen">
            B. enig beslag is gelegd op de goederen van de
            opdrachtgever en dit beslag niet binnen 14 dagen
            na de beslaglegging is opgeheven;
          </p>
          <p className="nitro-offscreen">
            C. de opdrachtgever niet voldoet aan enige op
            hem rustende verplichting uit de zoekopdracht
            en/of overeenkomst;
          </p>
          <p className="nitro-offscreen">
            D. de onderneming van de opdrachtgever wordt
            gestaakt, ontbonden, verkocht of geliquideerd.
          </p>
          <ul className="nitro-offscreen">
            <li>
              13.2. Indien zich een geval als bedoel in lid
              1 voordoet, is Synsel Techniek gerechtigd om,
              onverminderd zijn overige contractuele en
              wettelijke rechten en zonder nadere
              ingebrekestelling, middels een
              buitengerechtelijke verklaring en zonder tot
              enige schadevergoeding te kunnen worden
              gehouden:
            </li>
          </ul>
          <p className="nitro-offscreen">
            A. de nakoming van zijn verplichtingen jegens de
            opdrachtgever op te schorten;
          </p>
          <p className="nitro-offscreen">
            B. de zoekopdracht of overeenkomst geheel of
            gedeeltelijk, met onmiddellijke ingang, te
            ontbinden;
          </p>
          <p className="nitro-offscreen">
            C. alvorens over te gaan tot (verdere)
            uitvoering van een zoekopdracht of overeenkomst,
            afdoende zekerheid voor tijdige nakoming van de
            (betalings)verplichtingen van de opdrachtgever
            te verkrijgen.
          </p>
          <ul className="nitro-offscreen">
            <li>
              13.3. De opdrachtgever zal voorts alle
              (overige) maatregelen nemen en handelingen
              verrichten die noodzakelijk zijn om Synsel
              Techniek in staat te stellen om zijn rechten
              uit de overeenkomst of zoekopdracht uit te
              oefenen.
            </li>
            <li>
              13.4. Ontbinding en opschorting van de
              overeenkomst of zoekopdracht, dan wel
              tussentijdse beëindiging van de zoekopdracht
              of overeenkomst door de opdrachtgever, laat
              het recht van Synsel Techniek op vergoeding
              van de schade die hij dientengevolge lijdt,
              onverlet. Synsel Techniek zal jegens de
              opdrachtgever nimmer aansprakelijk zijn voor
              enige schade voor de opdrachtgever ontstaan in
              verband met opschorting en ontbinding van de
              zoekopdracht of overeenkomst zoals bedoeld in
              dit artikel.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 14. </strong>
            <strong>GEHEIMHOUDING EN PRIVACY </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              14.1. Alle informatie van welke aard dan ook
              die door Synsel Techniek in het kader van
              onderhandelingen, een zoekopdracht of
              overeenkomst aan de opdrachtgever wordt
              verstrekt, is strikt persoonlijk en
              vertrouwelijk. De opdrachtgever is verplicht
              om de hoogste mate van geheimhouding met
              betrekking tot die informatie in acht te nemen
              en is voorts gehouden om alle noodzakelijke
              maatregelen en voorzieningen te treffen om
              openbaring van die informatie aan derden te
              voorkomen.
            </li>
            <li>
              14.2. Indien de onderhandelingen tussen
              partijen niet resulteren in een zoekopdracht
              of overeenkomst, dan zal de opdrachtgever de
              hoogste mate van geheimhouding in acht nemen
              ten aanzien van de in het kader daarvan door
              Synsel Techniek verstrekte informatie van
              welke aard dan ook. De opdrachtgever zal die
              informatie nimmer verstrekken aan derden. De
              opdrachtgever zal daarnaast niet gerechtigd
              zijn om op enige wijze gebruik te maken van de
              door Synsel Techniek aangeleverde informatie
              van welke aard dan ook. De opdrachtgever dient
              op eerste verzoek van Synsel Techniek alle
              informatie en alle gegevensdragers aan Synsel
              Techniek te retourneren en alle daarvan
              gemaakte kopieën per direct te vernietigen.
            </li>
            <li>
              14.3. De opdrachtgever is gehouden de Algemene
              verordening gegevensbescherming (AVG) en
              daarmee samenhangende wet- en regelgeving te
              eerbiedigen met betrekking tot door Synsel
              Techniek, in het kader van zijn
              dienstverlening, verstrekte persoonsgegevens.
              Middels een duidelijk omschreven privacy
              beleid stelt de opdrachtgever de gedetacheerde
              op de hoogte van de wijze waarop de
              opdrachtgever persoonsgegevens verwerkt en op
              de rechten van de gedetacheerde ten aanzien
              van de verwerkte persoonsgegevens.
            </li>
            <li>
              14.4. De opdrachtgever vrijwaart Synsel
              Techniek voor aanspraken van personen van wie
              persoonsgegevens zijn geregistreerd of worden
              verwerkt in het kader van een
              persoonsregistratie die door de opdrachtgever
              wordt gehouden of waarvoor de opdrachtgever
              verantwoordelijk is.
            </li>
          </ul>
          <p className="nitro-offscreen">
            <strong> Artikel 15. </strong>
            <strong>
              TOEPASSELIJK RECHT, GESCHILLEN EN BEVOEGDE
              RECHTER
            </strong>
          </p>
          <ul className="nitro-offscreen">
            <li>
              15.1. Op elk aanbod van Synsel Techniek en op
              alle zoekopdrachten en overeenkomsten is
              Nederlands recht van toepassing.
            </li>
            <li>
              15.2. Alvorens een beroep te doen op de
              rechter, zijn partijen verplicht zich optimaal
              in te spannen om het geschil in onderling
              overleg te beslechten.
            </li>
            <li>
              15.3. Uitsluitend de bevoegde rechter binnen
              het arrondissement van de vestigingsplaats van
              Synsel Techniek wordt aangewezen om van
              gerechtelijke geschillen kennis te nemen.
            </li>
          </ul>
        </TextContent>
      </div>
    </div>
  );
}

export default TermsAndConditions;
